module.exports = __webpack_public_path__ + "img/station.3b0e0952.png";